import { render, staticRenderFns } from "./UserCreateTweet.vue?vue&type=template&id=06d4d5f3&"
import script from "./UserCreateTweet.vue?vue&type=script&lang=js&"
export * from "./UserCreateTweet.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateTweet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports